import { Component, type ErrorInfo, type ReactNode } from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';
import { productConfig } from '@shared/config';
import { Button } from '@/components/ui';
import i18n from '@/locales/i18n';

interface State {
  hasError: boolean;
}

export class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if (import.meta.env.DEV) console.error('Application render error', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="fatal-state">
        <div className="fatal-state__mark" aria-hidden="true">
          <AlertTriangle size={28} />
        </div>
        <p className="eyebrow">{productConfig.brandName}</p>
        <h1>{i18n.t('common:status.fatalTitle')}</h1>
        <p>{i18n.t('common:status.fatalBody')}</p>
        <Button onClick={() => window.location.reload()}>
          <RotateCcw size={17} />
          {i18n.t('common:actions.reload')}
        </Button>
      </main>
    );
  }
}
